import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  SignInResponse,
  TokenValidationResponse,
  MagicTokenValidationResponse,
} from "../../../model/auth-response";
import { setSession } from "../../../shared/storage";
import { Employee, UserInfo } from "../../../model/user";
import { USER_STATE } from "../../../shared/enums";
import { doCompanyEmployeeProfileUpdate } from "../../company/employees/employee.actions";

const initialState: {
  data: SignInResponse | null;
  user: UserInfo | null;
  employee: Employee | null;
  pending: boolean;
  error: boolean;
} = {
  data: null,
  user: null,
  employee: null,
  pending: false,
  error: false,
};

export const signinStore = createSlice({
  name: "signin",
  initialState,
  reducers: {
    signin(state) {
      return { ...state, pending: true, error: false };
    },
    signinSuccess(state, action: PayloadAction<SignInResponse>) {
      const { accessToken, ...user } = action.payload;

      const { id, email, name, companyId, employee } = user;
      if (action.payload.state !== USER_STATE.PENDING)
        setSession(id, email, accessToken, companyId);
      // @ts-ignore
      window.rudderanalytics.identify(id, {
        name: name,
        email: email,
      });
      return {
        ...state,
        data: action.payload,
        pending: false,
        user,
        employee: employee || null,
      };
    },
    signinFail(state) {
      return { ...state, pending: false, error: true };
    },
    validationSuccess(
      state,
      action: PayloadAction<
        TokenValidationResponse | MagicTokenValidationResponse
      >
    ) {
      const { accessToken, user, employee } = action.payload;

      const { id, email, companyId } = user || employee;

      setSession(id, email, accessToken, companyId);

      return {
        ...state,
        user: user || null,
        employee: user?.employee || employee || null,
        data: { accessToken, ...(user || employee) },
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      doCompanyEmployeeProfileUpdate.fulfilled,
      (state, action) => {
        state.employee = action.payload;
      }
    );
  },
});

export const { signin, signinFail, signinSuccess, validationSuccess } =
  signinStore.actions;
